import { Navigate } from 'react-router-dom';
import useProfile from '@/hooks/useProfile';

interface PremiumRouteGuardProps {
  children: React.ReactNode;
  requiredTier?: 'pro' | 'elite';
}

const PremiumRouteGuard = ({ children, requiredTier = 'pro' }: PremiumRouteGuardProps) => {
  const { isPremium, premiumTier, loading } = useProfile();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  const hasAccess = isPremium && (
    premiumTier === 'elite' || 
    (requiredTier === 'pro' && (premiumTier === 'pro' || premiumTier === 'elite'))
  );

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default PremiumRouteGuard;
